import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon/SvgIcon";

const ExclusionCategorical = props => (
  <SvgIcon viewBox="0 0 30 22" {...props}>
    <g fill="none" fillRule="evenodd">
      <rect width="14" height="14" x="16" fill="#4280BF" rx="1" />
      <path stroke="#FFF" strokeLinecap="round" d="M28 3.8l-6 6.4" />
      <rect width="14" height="14" fill="#4280BF" rx="1" />
      <path
        stroke="#FFF"
        strokeLinecap="round"
        d="M4.14 8.25L6 10.2M19.14 8.25l2.11 2M12 3.8l-6 6.4"
      />
      <rect width="14" height="14" x="8" y="8" fill="#C56E5B" rx="1" />
      <g stroke="#FFF" strokeLinecap="round">
        <path d="M12.2 12.5l5.64 5.67M17.65 12.5l-5.46 5.67" />
      </g>
    </g>
  </SvgIcon>
);

export default ExclusionCategorical;
